import React, { useEffect } from 'react';
import { ShieldCheck, TrendingUp, Users, ShieldAlert, Lock } from 'lucide-react';
import Button from './ui/Button';
import { tracking } from '../services/tracking';

interface LandingProps {
  onStart: () => void;
}

const Landing: React.FC<LandingProps> = ({ onStart }) => {

  useEffect(() => {
    tracking.trackEvent('landing_view');
  }, []);

  const handleStart = () => {
    tracking.trackEvent('quiz_start_click');
    onStart();
  };

  return (
    <div className="min-h-screen bg-brand-dark flex flex-col justify-center items-center relative overflow-hidden">
      {/* Premium Background Effects */}
      <div className="absolute inset-0 bg-brand-dark">
        {/* Tech Grid */}
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:50px_50px] opacity-20"></div>

        {/* Radial Glows */}
        <div className="absolute top-[-20%] left-[-10%] w-[500px] h-[500px] bg-brand-neon/20 rounded-full blur-[100px] animate-pulse duration-[4000ms]"></div>
        <div className="absolute bottom-[-20%] right-[-10%] w-[600px] h-[600px] bg-purple-600/20 rounded-full blur-[120px] animate-pulse duration-[7000ms]"></div>

        {/* Central Spotlight */}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-brand-dark/50 to-brand-dark"></div>
      </div>

      <div className="relative z-10 max-w-2xl w-full text-center space-y-8 animate-fade-in-up">

        {/* Warning Badge */}
        <div className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/30 text-red-400 px-4 py-1.5 rounded-full text-sm font-semibold uppercase tracking-wider mb-4">
          <ShieldAlert size={16} />
          <span>Atenção: 90% Perdem Dinheiro</span>
        </div>

        {/* Headline */}
        <h1 className="text-4xl md:text-6xl font-black text-white leading-tight tracking-tight">
          Você está investindo em Crypto com o <span className="text-brand-neon bg-brand-neon/10 px-2 rounded">Perfil Errado?</span>
        </h1>

        {/* Subheadline */}
        <p className="text-lg md:text-xl text-slate-300 leading-relaxed max-w-xl mx-auto">
          Faça o teste de <strong>1 minuto</strong>, descubra sua pontuação de risco e receba o
          plano exato para o seu momento financeiro.
        </p>

        {/* Action Area */}
        <div className="max-w-md mx-auto space-y-6 animate-fade-in-up delay-300">
          <Button fullWidth pulse className="text-xl py-6 shadow-[0_0_30px_rgba(16,185,129,0.3)]" onClick={handleStart}>
            FAZER DIAGNÓSTICO GRATUITO
          </Button>

          <p className="text-slate-500 text-xs text-center flex items-center justify-center gap-2">
            *Análise Gratuita • Resultados em 60 segundos
          </p>
        </div>

        {/* Social Proof / Trust Badges */}
        <div className="grid grid-cols-2 md:grid-cols-2 gap-4 pt-12 border-t border-slate-800/50 mt-12 opacity-70">
          <div className="flex flex-col items-center gap-2">
            <TrendingUp className="text-brand-neon w-8 h-8" />
            <span className="text-sm font-medium text-slate-400">Estratégia Validada</span>
          </div>
          <div className="flex flex-col items-center gap-2">
            <Lock className="text-brand-neon w-8 h-8" />
            <span className="text-sm font-medium text-slate-400">100% Seguro</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;